import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface PayPalStoreAccountInfo {
  id: number;
  paypalMerchantAccountId: number;
  payerId: string | null;
  transactionsReady: boolean;
}

export interface PayPalStoreAccountResponse {
  // Null when the store has no active assignment.
  account: PayPalStoreAccountInfo | null;
}

export const getPayPalStoreAccount = (
  storeId: number,
): AxiosPromise<PayPalStoreAccountResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/stores/${storeId}/paypal-account`,
  });
};
